export default __webpack_public_path__ + "static/media/198twofloorplan.3e1db5df.svg";